<template>
    <div class="w-100">
        <div class="label-container-desktop">
            <div ref="label" class="label-promo" v-html="labelOpt"/>
            <div v-if="timeCounter" class="label-timer" :data-timer="timeCounter"></div>
            <div v-if="timeCounter" class="label-timer-loader">
                <svg width="16" height="16">
                    <circle cx="8" cy="8" r="6"
                        stroke="#D90000" 
                        stroke-width="2" 
                        :stroke-dasharray="limitOffset" 
                        fill="none" 
                        :stroke-dashoffset="dashOffset" 
                        transform="rotate(-90,8,8)" 
                        stroke-linecap="but" />
                </svg> 
            </div>
        </div>
    </div>
</template>
<script>
import homeUtils from '@/Utilities/homeUtils';
export default {
    name: 'BlockLabelZoom',
    props:{
        timeCounter:{
            type: Number,
            default: 0
        },
        label:{
            type: String,
            default: null
        },
        limitOffset:{
            type: Number,
            default: 38
        }
    },
    data(){
        return {
            inViewPort: false,
            detectItemTimer: null,
            labelOpt: '',
            hours: 0,
            mins: 0,
            secs: 0,
            dashOffset: 38
        }
    },
    mounted() {
        this.removeClass();
        setTimeout(() => { this.timerRotate() }, this.randomStart());
    },
    methods: {
        randomStart() {
            let min = 5;
            let max = 1000;
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        timerRotate(){
            if(!this.timeCounter){
                return;
            }
            this.dashOffset = this.dashOffset - 1;
            if(this.dashOffset <= -this.limitOffset){
                this.dashOffset = this.limitOffset;
            }
            setTimeout(() => {this.timerRotate()}, 27);
        },
        removeClass(){
            this.labelOpt = homeUtils.removeClass(this.label);
        }
    }
}
</script>